import axios from 'axios';
import axiosInstance from './Axios/axiosInstance';
import authService from '../content/hooks/authService'
export const loginAdminstrator = async (email,password) => {
    try {
      
    //  const response = await axios.post('http://localhost:8080/login',{
      const response = await axios.post('https://resplendent-warmth-production.up.railway.app/login',{
        username:email,
        password:password
      });
      return response; // Return the data from the API response
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error; // Re-throw the error so it can be handled by the calling function
    }
  };


 const token = authService.getToken();

  export const loginAdminstratorTest = async (email,password) => {
      try {
        const response = await axios.get('https://appsail-50022064906.development.catalystappsail.in/messageLogin');
        return response; // Return the data from the API response
      } catch (error) {
        console.error('Error fetching notifications:', error);
        throw error; // Re-throw the error so it can be handled by the calling function
      }
    };


    export const fetchData = async () => {
      try {
        const response = await axiosInstance.post(`https://taxiapp-50022821344.development.catalystappsail.in/createNewMessageRequest`,{
          username:'gopi',
          password:'data'
        },
        {
          withCredentials: true // Only if your backend allows credentials
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
       return result;
      } catch (error) {
       throw error;
      }
    }


    export const pdfDownload =  async (rideBookingDTO) => {
      try {
         const response = await axios.post('https://resplendent-warmth-production.up.railway.app/pdf/download',rideBookingDTO, {
        //const response = await axios.post('http://localhost:8080/pdf/download',rideBookingDTO, {
              headers: {
                            'Content-Type': 'application/json',
                         
                            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                 }, 
                 responseType:'blob'  // Adjust method if necessary
          });
  
          console.log('Response received:', response);
  
          // Check if response status is OK (200)
        
              // Log headers to verify the content type
              const contentType = response.headers['content-type'];
              console.log('Content-Type:', contentType);
  
              if (contentType && contentType.includes('application/pdf')) {

                    const blob = new Blob([response.data], { type: 'application/pdf' });
          
    
        // Create a URL for the Blob object
        const url = window.URL.createObjectURL(blob);
    
        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = url;
    
        // Set the download attribute to the desired file name
        link.setAttribute('download', 'svr-taxi-bill.pdf');
    
        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);
    
        // Programmatically click the link to trigger the download
        link.click();
    
        // Clean up and remove the link after the download
        document.body.removeChild(link);
             

        return response;
          } else {
              console.error('Response Error:', response.status, response.statusText);
              throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
          }
      } catch (error) {
          // Enhanced error logging to capture details
          console.error('Error caught in catch block:', error);
          console.error('Error message:', error.message);
          console.error('Error stack:', error.stack);
  
          // Optionally, handle error in the UI or take action based on error type
      }
  };


  //   export const pdfDownload = async (rideBookingDTO) => {
  //     try {
  //         const response = await axios.post('https://taxiapp-50022821344.development.catalystappsail.in/pdf/download',rideBookingDTO,{
  //           headers: {
  //             'Content-Type': 'application/json',
  //         },
         
  //         });
  
  //         // Handle the response (which is your DTO)
  //         console.log('Response data:', response.data); // This will log the returned DTO
  
  //         // You can process the response data here if needed
  //         return response.data; // Return the DTO to the caller
  //     } catch (error) {
  //         console.error('Error fetching RideBookingDTO:', error);
  //         throw error; // Re-throw the error so it can be handled by the calling function
  //     }
  // };
  
export const messsageLogin = async (email,password) => {
  try {
    const response = await axiosInstance.post('/authenticate',{
      username:email,
      password:password
    });
    return response; // Return the data from the API response
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error; // Re-throw the error so it can be handled by the calling function
  
  }
}

  export const saveLocalPackage = async (localPackage) => {
    try {
      const response = await axiosInstance.post('https://resplendent-warmth-production.up.railway.app/teriff/local-package',localPackage,{
        headers: {
          'Content-Type': 'application/json',
       
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
}, 
      });
      return response; // Return the data from the API response
    } catch (error) {
      console.error('Error in save local package:', error);
      throw error; // Re-throw the error so it can be handled by the calling function
    }
  }

    export const saveCommonPackage = async (commonPackage) => {
      try {
        const response = await axiosInstance.post('https://resplendent-warmth-production.up.railway.app/teriff/common-package',commonPackage,{
          headers: {
            'Content-Type': 'application/json',
         
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
 }, 
        });
        return response; // Return the data from the API response
      } catch (error) {
        console.error('Error in save common teriff:', error);
        throw error; // Re-throw the error so it can be handled by the calling function
      }
    }
      export const saveYercaudPackage = async (yercaudPackage) => {
        try {
          const response = await axiosInstance.post('https://resplendent-warmth-production.up.railway.app/teriff/yercaud-package',yercaudPackage,{
            headers: {
              'Content-Type': 'application/json',
           
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
   }, 
          });
          return response; // Return the data from the API response
        } catch (error) {
          console.error('Error in save yercaud teriff:', error);
          throw error; // Re-throw the error so it can be handled by the calling function
        }
      
    
}

export const getTeriffData = async () => {
  try {
    const response = await axiosInstance.get('http://localhost:8080/teriff/package');
    return response; // Return the data from the API response
  } catch (error) {
    console.error('Error in save yercaud teriff:', error);
    throw error; // Re-throw the error so it can be handled by the calling function
  }


};